// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'digitalNumbers', monaco, consolas, Lucida Console, Andale Mono, monospace","fontWeight":400},"className":"__className_00b4c2","variable":"__variable_00b4c2"};